import styled from 'styled-components';
import { IThemeProvider, ITheme } from '../../styles/theme';

export const CheckboxCont = styled.div`
  display: block;
  position: relative;
  padding-left: 24px;
  margin-bottom: 17px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: fit-content;

  &:hover input ~ span {
    ${({ theme }: IThemeProvider) => `
      background-color: ${theme.colors.secondary[10]};
    `}
  }

  & input:checked ~ span {
    ${({ theme }: IThemeProvider) => `
      background-color: ${theme.colors.secondary[30]};
    `}
  }

  & input:checked ~ span::after {
    display: block;
  }
`;

export const CheckboxInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

interface ICheckbox {
  rounded: boolean;
  disabled?: boolean;
  theme: ITheme;
}

export const Checkmark = styled.span<ICheckbox>`
  position: absolute;
  top: 0;
  left: 0;
  ${({ theme, disabled, rounded }: ICheckbox) => `
      height: ${rounded ? '24px' : '18px'};
      width: ${rounded ? '24px' : '18px'};
      background-color: ${theme.colors.neutral.primary[0]};
      border: 2px solid ${theme.colors.secondary[100]};
      border-radius: ${rounded ? '24px' : '4px'};
      opacity: ${disabled ? '0.5' : '1'};
      cursor: ${disabled ? 'not-allowed' : 'pointer'};
    `}

  &::after {
    content: '';
    position: absolute;
    display: none;
    border: solid black;
    ${({ theme, rounded }: ICheckbox) => `
      height: ${rounded ? '12px' : '10px'};
      width: ${rounded ? '12px' : '5px'};
      border-radius: ${rounded ? '12px' : ''};
      top: ${rounded ? '21%' : '1px'};
      left: ${rounded ? '20%' : '5px'};
      ${
  !rounded
    ? `border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);`
    : `background: ${theme.colors.neutral.primary[100]}`
}
    `}
  }
`;
